import en from 'element-plus/lib/locale/lang/en';
import es from 'element-plus/lib/locale/lang/es';
// import fr from 'element-plus/lib/locale/lang/fr';
import ar from 'element-plus/lib/locale/lang/ar';
import id from 'element-plus/lib/locale/lang/id';
import ja from 'element-plus/lib/locale/lang/ja';
import kk from 'element-plus/lib/locale/lang/kk';
import nl from 'element-plus/lib/locale/lang/nl';
import pl from 'element-plus/lib/locale/lang/pl';
import pt from 'element-plus/lib/locale/lang/pt';
import ptBr from 'element-plus/lib/locale/lang/pt-br';
import ro from 'element-plus/lib/locale/lang/ro';
import ru from 'element-plus/lib/locale/lang/ru';
import th from 'element-plus/lib/locale/lang/th';
import tr from 'element-plus/lib/locale/lang/tr';
import uk from 'element-plus/lib/locale/lang/uk';
import vi from 'element-plus/lib/locale/lang/vi';
import zhMy from 'element-plus/lib/locale/lang/zh-cn'; // 已和 @luna确认，zh-cn 映射zh-MY
import zhTw from 'element-plus/lib/locale/lang/zh-tw';

// 国际化缩写映射表
export const LocaleMap = {
    en: 'en', // 英语
    // 'en-US': 'en', // 下架美式英语
    'en-HK': 'en', // 英语(香港)
    'es-ES': 'es', // 西班牙语
    // 'fr-FR': 'fr', // 下架法语（合规化）
    'id-ID': 'id', // 印尼语
    'ja-JP': 'ja', // 日本语
    // 'ko-KR', // 下架韩语
    'pt-BR': 'ptBr', // 巴西葡萄牙语
    'ru-RU': 'ru', // 俄语
    'th-TH': 'th', // 泰语
    'tr-TR': 'tr', // 土耳其语
    'vi-VN': 'vi', // 越南语
    // 'zh-CN': 'zhMy', // 下架简体中文（合规化）
    'zh-MY': 'zhMy', // 中文（马来西亚）
    'zh-HK': 'zhTw', // 繁体中文(香港)
    'zh-TW': 'zhTw', // 繁体中文（台湾）
    // 'fil-PH':'fil-PH', // 官方暂不支持，是否需要自己翻译
    // 'hi-IN': 'hi-IN',  // 官方暂不支持，是否需要自己翻译
    'kk-KZ': 'kk', // 哈萨克斯坦语
    'uk-UA': 'uk', // 乌克兰语
    'pt-PT': 'pt', // 葡萄牙语
    'ar-SA': 'ar', // 阿拉伯语
    'es-MX': 'es', // 墨西哥西班牙语
    'es-AR': 'es', // 阿根廷西班牙语
    'es-419': 'es', // 拉美西班牙语
    'nl-NL': 'nl', // 荷兰语
    'en-NL': 'en', // 荷兰语（英语）
    'pl-PL': 'pl', // 波兰语
    'ro-RO': 'ro', // 罗马尼亚语
    'kk-KAZ': 'kk',
    'en-KAZ': 'en',
    'ru-KAZ': 'ru',
    'tr-TUR': 'tr',
    'en-EU': 'en',
    'pl-POL': 'pl',
    'ro-ROU': 'ro',
    'es-ESP': 'es',
    'pt-PRT': 'pt',
};

export const ElementLocales = {
    en,
    es,
    // fr,
    id,
    ja,
    ptBr,
    pt,
    ro,
    ru,
    th,
    tr,
    vi,
    kk,
    uk,
    zhMy,
    zhTw,
    ar,
    nl,
    pl,
};

// 获取 Element UI 的国际化语言包
export function getElementLocale(lang) {
    const cur = LocaleMap[lang] || 'en';
    return ElementLocales[cur];
}
